import 'css/desktop/post-list.scss';

import 'js/desktop/common/common.jquery.js';
